import React from "react";
import PastJobsMainComponent from "../components/PastJobs/PastJobsMainComponent";

const PastJobsPage = () => {
  return <PastJobsMainComponent />;
};

export default PastJobsPage;